import { Box } from '@material-ui/core';
import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';
import { sortByDateReverse } from '../../../../../../../jsx/actions/utils';
import PopUp from '../../../../commonModules/interface/PopUp';
import SwipeableTabs from '../../../../commonModules/MUI/SwipeableTabs';
import ClientInfo from './ClientInfo';
import ClientHistory from './ClientHistory';
import { useFetchTransfers } from '../../../../../../../jsx/hooks/getTransfers';

const ClientPopUp = (props) => {
    const fetchTransfers = useFetchTransfers("vente");
    const [state,setState] = useState({
        historySale: [],
        history: [],
    })
    useEffect(() => {
        if( isEmpty(props.SALES) ) {
            fetchTransfers();
        }else{
            findClientHistory()
        }
    }, []);
    useEffect(() => {
        findClientHistory()
    }, [props.SALES]);

    const findClientHistory = () => {
        let history = []
        let historySale = []
        const { SALES, client, PRODUCTS } = props;
        if( !isEmpty(SALES) ) {
            let list = Object.values(SALES)            
            console.log("[DEBUG],findClientHistory,=>",list.length," - ",client.id,"-",list[0])

            list = list.filter( op => op.client_id === client.id)
            sortByDateReverse(list, "date")
            console.log("[DEBUG],findClientHistory,=>",list.length," - ",client.id)

            list.forEach( op => {
                // op.products.forEach( prod => {
                //     history.push({
                //         history_date: op.date,
                //         history_product: prod.product_id,
                //         history_quantity: prod.quantity,
                //         history_stock_cost: prod.stock_cost,
                //         operation: op.nature,
                //         product: PRODUCTS[prod.product_id],
                //         price: prod.price,
                //         // price: prod.sale_item_PU,
                //         history_id: op.id,
                //         // history_price: 0,
                //         // history_priceHT: 0,
                //         // history_price_out: 0,
                //         // history_pu: 0,
                //         // history_shop_id: "",
                //     })
                // })
                
                historySale.push({
                    history_date: op.creation_date,
                    history_id: op.id,
                    operation: op.nature,
                    total: op.total_price
                })
            })
        }
        console.log("[DEBUG],findClientHistory,=>",historySale)

        setState(prevState => ({...prevState,
            history,
            historySale
        }))
    }
        return (
            <PopUp
                title={`${props.client.client_firstname} ${props.client.client_lastname}`}
                close={props.closePopUp}
            >

                <SwipeableTabs
                    labels={["ClientInfo","Historique", "Dashboard"]}
                    default="ClientInfo" 
                >
                    
                    <ClientInfo {...state} {...props} />
                    <ClientHistory {...state} {...props} />
                    <Box>
                        Bientôt disponible
                    </Box>

                </SwipeableTabs>
            </PopUp>
        );
}

export default ClientPopUp;